'use client'

import { useEffect, useRef, type ReactNode } from 'react'

/**
 * Scroll-reveal progressivo. Lo stato base è VISIBILE: senza JS, prima
 * dell'idratazione o con reduced-motion il contenuto si vede sempre. Quando il
 * JS rileva l'ingresso nel viewport aggiunge .is-visible che fa partire il
 * fade-up (gestito in globals.css, gate prefers-reduced-motion).
 */
export function Reveal({ children, delay = 0, className = '' }: { children: ReactNode; delay?: number; className?: string }) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-visible')
      return
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible')
          io.disconnect()
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <div ref={ref} className={`reveal ${className}`} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </div>
  )
}
